import { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
// mocks_
import account from '../../../_mock/account';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
  },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
  }
];

// ----------------------------------------------------------------------

export default function AccountPopover({isAdmin}) {
  const [open, setOpen] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(sessionStorage.getItem('AvatarUrl'));

  useEffect(() => {
      // 監聽 sessionStorage 中 AvatarUrl 的變化
      setAvatarUrl(sessionStorage.getItem('AvatarUrl'));
  }, [sessionStorage.getItem('AvatarUrl')]);


  const navigate = useNavigate();

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };
  const handleLoginOut = () => {
    sessionStorage.clear();
    setOpen(null);
    navigate('/login', { replace: true });
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleNav = (option) => {
    setOpen(null);
  
    if (!isAdmin) {
      if (option === 'Home') {
        navigate('/staff/info');
      } else if (option === "Profile") {
        navigate('/staff/detail');
      }
    } 
    
    if (isAdmin) {
      if (option === 'Home') {
        navigate('/admin/staffmanage');
      } else if (option === "Profile") {
        navigate('/admin/detail');
      }
    } 

      // 在管理员和非管理员之间共享的部分，您可以在这里添加代码       
  };
  

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={avatarUrl} alt={sessionStorage.getItem('StaffName')} />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {sessionStorage.getItem('StaffName')}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            員編:{sessionStorage.getItem('StaffNo')}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={()=>handleNav(option.label)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLoginOut} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>
    </>
  );
}
